import axiosInstance from '../axiosInterceptor/axiosInstance'
import selectedOrgId from '../../utils/helpers/selectedOrgId'

const getPlayerPositions = async () => {
  const url = `v1/orgs/${selectedOrgId()}/players/positions`

  return axiosInstance.get(url).then(({data}) => {
    return {
      data: data,
      total: data.length,
    }
  })
}

export default getPlayerPositions
